module.exports = __webpack_public_path__ + "static/media/VGS_Desktop_02.5ee4e87d.png";